export default __webpack_public_path__ + "static/media/icon_arrow.93e09cef.svg";